import { createReactInlineContentSpec } from '@blocknote/react';

import { TOKEN_INLINE_CONFIG } from './config';
import { InlineTokenRenderer } from './token-inline-renderer';

export const tokenInlineSpec = createReactInlineContentSpec(
  TOKEN_INLINE_CONFIG,
  {
    render: InlineTokenRenderer,
  },
);
